import React from "react"
import { generatePath, Link, withRouter } from "react-router-dom"

import NotificationCard from "../notificationCard"
import getErrorText from "../../../../library/constants/errorTypes"
import { withSnackbar } from "notistack"
import * as routes from "../../../../library/constants/routes"

import "./notificationsSidebar.scss"
import Loader from "../../../../components/ui/loader/loader"

class NotificationsSidebar extends React.Component {
  state = {
    dataReceived: false,
  }

  async componentDidMount() {
    try {
      await this.props.getNotificationSmallList({ limit: 5 })
      this.setState({ dataReceived: true })
      this.props.clearNotificationCount()
    } catch ({ error }) {
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
  }

  componentWillUnmount() {
    this.props.clearNotificationSmallList()
  }

  render() {
    const {
      notifications: { notificationSmallList, unreadCounter },
      deleteNotification,
      updateNotificationList,
      getNotificationSmallList,
      decrementUnreadCount,
    } = this.props
    const { dataReceived } = this.state

    return (
      <div className="box notifications-sidebar__container">
        <div className="box__heading">Notifications</div>
        {dataReceived ? (
          !!notificationSmallList.length ? (
            <>
              {notificationSmallList.slice(0, 5).map((item, i) => {
                return (
                  <NotificationCard
                    key={item.id}
                    notification={item}
                    isRead={i >= unreadCounter}
                    deleteNotification={deleteNotification}
                    updateNotifications={updateNotificationList}
                    notificationsLength={notificationSmallList.length}
                    getNotificationSmallList={getNotificationSmallList}
                    decrementUnreadCount={decrementUnreadCount}
                  />
                )
              })}

              <div className="h-divider"></div>

              <div className="notifications-sidebar__footer">
                {!notificationSmallList.length && (
                  <div>Notifications not found</div>
                )}
                {!!notificationSmallList.length && (
                  <Link
                    className="link"
                    to={generatePath(routes.NOTIFICATIONS, {
                      userId: this.props.auth.userData.id,
                    })}
                  >
                    Show all
                  </Link>
                )}
              </div>
            </>
          ) : (
            <div className="box__content">
              <div className="f jcc color-black-54">
                There are no notifications
              </div>
            </div>
          )
        ) : (
          <Loader />
        )}
      </div>
    )
  }
}

export default withRouter(withSnackbar(NotificationsSidebar))
